<div style="margin-right: 32px;">
  <div>
      <h4 class="title" style="margin-top: 15px;">Excel Upload</h4>
  </div>
</div>
<div class="card-box" style="margin: 2px;padding-bottom: 15px;">
  <div class="">
      <h4 class="title-f">Upload a file</h4>
      <div class="profile-form-edit">
          <div class="upload-btn-wrapper mt-3">
              <input type="file" (change)="onFileChange($event)" multiple="false" accept=".xlsx" />
          </div>
      </div>

  </div>
</div>
<!-- <div class="social-edit" id="sn">
  <div class="container">
      <div class="row">
          <div class="col-lg-12 mb-3">
              <div class="sub-btn">
                  <button class="btn">submit</button>
              </div>
          </div>
          <div class="col-lg-12 ">
              <div class="over-table">
                  <table class="sjs-table">
                      <tbody>
                          <tr *ngFor="let row of data">
                              <td *ngFor="let val of row">
                                  {{val}}
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
          <div class="col-lg-12 mt-3">
              <B *ngIf="ErrorShow === false">Error :</B>
              <ng-container *ngFor="let data of Error">
                  <p style="color: #f90202 !important;">{{data}}</p>
              </ng-container>
          </div>
      </div>
  </div>

</div> -->
<ng-container *ngIf="data.length > 0">
  <div class="card-box" style="margin: 20px 2px;padding-bottom: 15px;">
      <div class="row" style="margin-bottom: 10px;">
          <!-- <div class="col-md-3">
          <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText placeholder="Account Search" />
          </span>
      </div>
      <div class="col-md-3">
          <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText placeholder="Full Search" />
          </span>
      </div> -->
          <div class="col-md-12">
              <h4 class="title-f">Assign</h4>
          </div>
          <!-- <button class="btn btn-primary" style="margin-right: 10px;">Personal Loan</button>

          <button class="btn btn-primary" style="margin-right: 10px;">Auto Loan</button>

          <button class="btn btn-primary" style="margin-right: 10px;">Credit Cards</button>

          <button class="btn btn-primary" style="margin-right: 0px;">Sales Finance</button> -->
          <div class="col-md-4">
              <h5 class="form-lable">Portfolio:</h5>
              <select>
                  <option>Select</option>
                  <option>Personal Loan</option>
                  <option>Auto Loan</option>
                  <option>Credit Cards</option>
                  <option>Sales Finance</option>
              </select>

          </div>
          <div class="col-md-4">
              <h5 class="form-lable">Assign To:</h5>
              <select>
                  <option>Select</option>
                  <option>User-1</option>
                  <option>User-2</option>
                  <option>User-3</option>
                  <option>User-4</option>
              </select>
          </div>
          <div class="col-md-4">
              <button class="btn btn-primary" style="margin-right: 0px;">Assign</button>
          </div>
      </div>
  </div>
  <div class="doc-table">

      <div class="card-box"> <p-table [value]="data" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="50" [rowHover]="true"
          [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">

          <ng-template pTemplate="header">

              <!-- <tr style="text-align: center;" class="thhead">
            <th style="width: 50px;">S.No</th>
            <th>Account No</th>
            <th>Customer No</th>
            <th>Name</th>
            <th>Portfolio</th>
            <th>Bucket:</th>
            <th>OS Amount:</th>
            <th>OD Amount:</th>
            <th>Phone Number</th>
            <th style="width: 100px;">Action</th>
          </tr> -->


          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">

              <tr style="text-align: center;" *ngIf="i == 0" class="thhead">
                  <th *ngFor="let val of item">
                      {{val}}
                  </th>
              </tr>


              <tr class="tdrow" *ngIf="i > 0">
                  <td *ngFor="let val of item">
                      {{val}}
                  </td>
                  <!-- <td class="act">
                      <i style="color: #2196f3;" class="fa fa-pencil-square-o" aria-hidden="true" pTooltip="Edit"></i>
                      <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete"></i>
                      <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="profile()" pTooltip="Profile"></i>
                  </td> -->
              </tr>

          </ng-template>
       </p-table>  </div>

  </div>
</ng-container>
